/** Human-readable byte size (e.g. 1536 → "1.5 KB"). */
export const formatBytes = (bytes?: number | null): string => {
  if (!bytes || bytes <= 0) {
    return '0 B';
  }

  const units = ['B', 'KB', 'MB', 'GB', 'TB'];
  const exponent = Math.min(
    Math.floor(Math.log(bytes) / Math.log(1024)),
    units.length - 1,
  );
  const value = bytes / 1024 ** exponent;

  return `${value.toFixed(exponent === 0 ? 0 : 1)} ${units[exponent]}`;
};

interface IZoomFile {
  file_type?: string;
  recording_type?: string;
}

/** Safely parses the `ZoomRecording.files` JSONString into an array. */
export const parseZoomFiles = (raw?: string | null): IZoomFile[] => {
  if (!raw) {
    return [];
  }

  try {
    const parsed = JSON.parse(raw);
    return Array.isArray(parsed) ? parsed : [];
  } catch {
    return [];
  }
};
